export default __webpack_public_path__ + "static/media/banner-2.bb43cdd0.webp";